import officesActions from './actions';
import storeResourceFactory from '../../libs/storeResourceFactory';

const officesStore = storeResourceFactory('offices', {});

const state = {
  ...officesStore.state,
};

const actions = {
  initializeOffices: officesStore.request(officesActions.initializeOffices),
};

const mutations = {
  ...officesStore.mutations,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/offices/index.js